<div class="grid-col-12 grid-max-width no-row-gap padding-left-gutter padding-right-gutter center">
  <h1 class="nordic-blue-900-text col-1-12 ms-medium-y ms-xxlarge-b" *ngIf="heading$ | async">
    {{ heading$ | async }}
  </h1>

  <fin-ond-marketing-cross-linking
    *ngIf="route.url | async"
    class="section-two-thirds-right col-1-12 md-col-1-9 ms-large-b"
    [route]="route.url | async"
    [links$]="pairs$"
    [ondPageType]="ondPageType"
  >
  </fin-ond-marketing-cross-linking>
</div>
